<div class="container my-5">
  <div class="text-center p-5">
    <h2>Introduce el código de validación</h2>
    <p>Se ha enviado un código de validación a tu correo electrónico. Por favor, ingrésalo a continuación para completar tu registro.</p>

    <form (ngSubmit)="onSubmit()" [formGroup]="codigoForm">
      <div class="mb-3  row justify-content-center">
        <label for="codigo" class="form-label">Código de activación</label>

        <!-- Contenedor para las 6 cajas de texto -->
        <div class="col-12 col-md-10 d-flex justify-content-center">
          <ng-container *ngFor="let campo of campos; let i = index">
            <input
              type="text"
              [id]="'codigo' + (i + 1)"
              maxlength="1"
              class="form-control mx-1 text-center"
              [formControlName]="'codigo' + (i + 1)"
              (input)="onInput($event, i)"
              (keydown)="onKeyDown($event, i)"
            />
          </ng-container>
        </div>

        <div *ngIf="codigoForm.invalid && codigoForm.touched" class="text-danger">
          El código debe contener exactamente 6 dígitos.
        </div>
      </div>

      <button type="submit" class="btn btn-primary" [disabled]="codigoForm.invalid">Activar cuenta</button>
    </form>

    <div *ngIf="validacionError" class="alert alert-danger mt-3">
      El código ingresado es incorrecto. Por favor, intenta nuevamente.
    </div>
  </div>
</div>
